/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Limits_TitleInputs */

const en_svc_n8n_limits_title = /** @type {(inputs: Svc_N8n_Limits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we will not hand you.`)
};

const lv_svc_n8n_limits_title = /** @type {(inputs: Svc_N8n_Limits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko mēs Jums nenodosim.`)
};

/**
* | output |
* | --- |
* | "What we will not hand you." |
*
* @param {Svc_N8n_Limits_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_limits_title = /** @type {((inputs?: Svc_N8n_Limits_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Limits_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_limits_title(inputs)
	return en_svc_n8n_limits_title(inputs)
});